<!-- Page Banner -->
<div class="page-banner-area item-bg3">
    <div class="container">
        <div class="page-banner-content">
            <h2>Our Leadership</h2>
            <ul>
                <li><a routerLink="/">Home</a></li>
                <li>Our Leadership</li>
            </ul>
        </div>
    </div>
</div>
<!-- End Page Banner -->

<!-- About -->
<section class="about-area ptb-100">
    <div class="container-fluid">
        <div class="row">
            <div class="col-lg-6 col-md-12">
                <div class="about-image-warp image-three"></div>
            </div>

            <div class="col-lg-6 col-md-12">
                <div class="about-content warp">
                    <span>Our Leadership</span>
                    <p>MicroSync Technologies Management team includes industry experts who carries extensive
                        experience in their
                        respective domains,
                        committed to MicroSync Technologies vision and strategic focus. Believes in setting right
                        direction, pace,
                        managing and motivating to achieve greater heights.</p>
                    <br />
                    <br />
                    <br />
                    <br />
                    <br />
                    <br />
                </div>
            </div>
        </div>
    </div>
</section>
<!-- End About -->

<!-- Team -->
<!-- <section class="team-area pb-100">
    <div class="container-fluid">
        <div class="section-title">
            <h2>Our Leadership</h2>
            <div class="bar"></div>
        </div>
        <div class="row">
            <div class="col-lg-3 col-md-3">
            </div>
            <div class="col-lg-3 col-md-3">
                <div class="single-team">
                    <div class="image">
                        <img src="assets/img/team/team-1.jpg" alt="image">

                        <ul class="social">
                            <li><a href="#" target="_blank"><i class='bx bxl-facebook'></i></a></li>
                            <li><a href="#" target="_blank"><i class='bx bxl-twitter'></i></a></li>
                            <li><a href="#" target="_blank"><i class='bx bxl-instagram'></i></a></li>
                            <li><a href="#" target="_blank"><i class='bx bxl-linkedin'></i></a></li>
                        </ul>

                        <div class="content">
                            <h3>Chandrakant Kshirsagar</h3>
                            <span>Co-Founder & CEO</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-3 col-md-3">
                <div class="single-team">
                    <div class="image">
                        <img src="assets/img/team/team-2.jpg" alt="image">

                        <ul class="social">
                            <li><a href="#" target="_blank"><i class='bx bxl-facebook'></i></a></li>
                            <li><a href="#" target="_blank"><i class='bx bxl-twitter'></i></a></li>
                            <li><a href="#" target="_blank"><i class='bx bxl-instagram'></i></a></li>
                            <li><a href="#" target="_blank"><i class='bx bxl-linkedin'></i></a></li>
                        </ul>

                        <div class="content">
                            <h3>Priyanka Kshirsagar</h3>
                            <span>Co-Founder & CEO</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-3 col-md-3">
            </div>
        </div>
    </div>
</section> -->
<!-- End Team -->